import { each } from 'lodash';
const _underscored = require('underscore.string/underscored');
const _titleize = require('underscore.string/titleize');
const _words = require('underscore.string/words');
const _capitalize = require('underscore.string/capitalize');

const superHumanize = (string: string) => {
  // the standard str.humanize kills _id$
  string = _underscored(string).replace(/_/g, ' ').replace(/\[\]/g, ' ');
  const out = _titleize(_capitalize(string));
  const words = _words(out);
  const subs = {
    Url: 'URL',
    Uri: 'URI',
    Html: 'HTML',
    Id: 'ID',
    id: 'ID',
  };
  each(subs, function (v, k) {
    const index = words.indexOf(k);
    if (index !== -1) {
      words[index] = v;
    }
  });
  return words.join(' ');
};

export default superHumanize;
